<div class="action-wrapper" (click)="$event.stopPropagation()">
  <button class="view-link" (click)="onViewDetails()">
    View
  </button>
</div>